/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilterAdminDto } from '../../models/filter-admin-dto';
import { ResponseAdminDto } from '../../models/response-admin-dto';

export interface AdminsControllerFilter$Params {
  
    /**
     * The filtering criteria
     */
    body: FilterAdminDto
}

export function adminsControllerFilter(http: HttpClient, rootUrl: string, params: AdminsControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseAdminDto>>> {
  const rb = new RequestBuilder(rootUrl, adminsControllerFilter.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseAdminDto>>;
    })
  );
}

adminsControllerFilter.PATH = '/thalea-admins/admins/filter';
